import { User } from "@saleor/fragments/types/User";
import MfaAuthPage from "@saleor/mfa/components/MfaAuthPage/MfaAuthPage";
import MfaGetStartedPage from "@saleor/mfa/components/MfaGetStartedPage/MfaGetStartedPage";
import MfaInputEmailCodePage from "@saleor/mfa/components/MfaInputCodePage/MfaInputEmailCode";
import MfaInputPhoneCodePage from "@saleor/mfa/components/MfaInputCodePage/MfaInputPhoneCode";
import React from "react";
import { Route, Routes, useParams } from "react-router-dom";

import Layout from "./components/Layout";
import { StoreProvider } from "./store/StoreContext";
import {
  chooseAccountPath,
  contactUsPath,
  newPasswordPath,
  passwordResetPath,
  passwordResetSuccessPath,
  userLoginPath,
  userOTPPath,
  userSignupPath
} from "./urls";
import ChooseAccount from "./views/ChooseAccount";
import ContactUsView from "./views/ContactUs";
import HomepageView from "./views/Homepage";
import LoginView from "./views/Login";
import NewPassword from "./views/NewPassword";
import OTPView from "./views/OTPVerify";
import ResetPassword from "./views/ResetPassword";
import ResetPasswordSuccess from "./views/ResetPasswordSuccess";
import SignupView from "./views/Signup";

const OTPVerifyView: React.FC = () => {
  const { id } = useParams();
  return <OTPView id={decodeURIComponent(id)} />;
};

export interface UserWithSmopDetails extends User {
  userType: any; // TODO: Improve this type
}

interface UserContext {
  login: (username: string, password: string) => void;
  loginByToken: (auth: string, csrf: string, user: User) => void;
  logout: () => void;
  tokenAuthLoading: boolean;
  tokenRefresh: () => Promise<boolean>;
  tokenVerifyLoading: boolean;
  user?: UserWithSmopDetails;
  userDetail?: User;
}

export const UserContext = React.createContext<UserContext>({
  login: undefined,
  loginByToken: undefined,
  logout: undefined,
  tokenAuthLoading: false,
  tokenRefresh: undefined,
  tokenVerifyLoading: false
});

const AuthRouter: React.FC = () => (
  <Layout>
    <StoreProvider>
      <Routes>
        <Route
          path={"/mfa-verification-page/"}
          element={<MfaGetStartedPage />}
        />
        <Route path={"/mfa-auth-page/"} element={<MfaAuthPage />} />
        <Route
          path={"/mfa-email-input-page/"}
          element={<MfaInputEmailCodePage />}
        />
        <Route
          path={"/mfa-phone-input-page/"}
          element={<MfaInputPhoneCodePage />}
        />
        <Route
          path={passwordResetSuccessPath + "/"}
          element={<ResetPasswordSuccess />}
        />
        <Route path={passwordResetPath + "/"} element={<ResetPassword />} />
        <Route path={userLoginPath + "/"} element={<LoginView />} />
        <Route path={chooseAccountPath + "/"} element={<ChooseAccount />} />
        <Route path={newPasswordPath + "/"} element={<NewPassword />} />
        <Route path={userSignupPath + "/"} element={<SignupView />} />
        <Route path={userOTPPath + "/"} element={<OTPVerifyView />} />
        <Route path={contactUsPath + "/"} element={<ContactUsView />} />
        {/* <Route path={userBusinessDetailsPath} component={BusinessDetailsView} /> */}
        <Route path="*" element={<HomepageView />} />
      </Routes>
    </StoreProvider>
  </Layout>
);

AuthRouter.displayName = "AuthRouter";
export default AuthRouter;

export * from "./utils";
